import { forwardRef, useId } from 'react';
import { alpha, styled } from '@mui/material/styles';
import Select from "@mui/material/Select";
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const SelectField = styled(Select)(({ theme }) => ({
  ":hover": {
    backgroundColor: alpha('#ccc', 0.25),
    'MuiOutlinedInput-notchedOutline': {
      // borderColor: 'primary.main'
    }
  },
  background: 'white',
  // background: '#f1f2f4',
  borderRadius: '6px',
  // borderRadius: `16px`,
  color: '#000',
  '& .MuiFormControl-root': {
    // color: "rgb(0 0 0 / 80%)",
    color: '#000',
  },
  '& .MuiInputBase-input': {
    // color: "rgb(0 0 0 / 80%)",
    color: '#000',
  },
  '& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '10px 14px',
  },
  ':hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      // borderColor: (theme) theme.colors?.grey400
      borderColor: theme.palette.primary.main + ' !important'
    }
  },

  '&:hover $notchedOutline': {
    borderColor: '#000 !important'
  },

  '&.MuiInputBase-multiline': {
    padding: 1
  },
  "&  .MuiFormHelperText-root.Mui-error": { //<--- here
    // backgroundColor: "red",
    margin: 0,
    paddingLeft: 10
  },

  // '& .MuiOutlinedInput-root': {
  //     '& fieldset': {
  //         borderColor: (theme) => theme.palette.primary.main
  //     },
  //     '&:hover fieldset': {
  //         borderColor: (theme) => theme.palette.primary.main
  //     },
  //     '&.Mui-focused fieldset': {
  //         borderColor: (theme) => theme.palette.primary.main
  //     },
  //   },
  '& .Mui-disabled': {
    backgroundColor: '#e9ecef',
    cursor: 'not-allowed',
    pointerEvents: 'all',
    ':hover': {
      backgroundColor: '#e9ecef',
    }
  },
  input: {
    fontWeight: 500,
    background: 'white',
    // background: '#f1f2f4',
    padding: '15.5px 14px',
    //   borderRadius: `16px`,
    borderRadius: '8px',

    '&.MuiInputBase-inputSizeSmall': {
      padding: '10px 14px',
      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: 0
      }
    },
    '& .MuiInputBase-inputSizeSmall.xs': {
      padding: '2.5px 14px',
      ' &.MuiInputBase-inputAdornedStart': {
        paddingLeft: 0
      }
    }
  },

  inputAdornedStart: {
    paddingLeft: 4
  },
  notchedOutline: {
    //   borderRadius: `16px`
  }
}));

const FormLabelStyled = styled(FormLabel)({
  padding: '4px',
  fontWeight: 600,
  color: '#000',
  fontSize: 15,
});

const ITEM_HEIGHT = 80;
const ITEM_PADDING_TOP = 8;
const CustomMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const SelectInput = forwardRef((props, ref) => {

  const {
    labelAbove = false,
    labelLeft = false,
    fullWidth = true,
    rounded = false,
    labelSx = {},
    sx = {},
    gridProps = {
      left: {
        xs: 12,
        md: 6
      },
      right: {
        xs: 12,
        md: 6
      }
    },
    formControlClasses = "",
    helperText,
    helperTextSx = {},
    isError = true,
    forceHelper = false,
    useCustomMenuProps = true,
    CustomMenuProps = {},
    MenuProps = useCustomMenuProps ? CustomMenuProps : {},
    displayEmpty = true,
    size = 'small',
    ...other
  } = props;

  const RenderSelectField = () => (
    <SelectField
      displayEmpty={displayEmpty}
      MenuProps={{
        disableScrollLock: false,
        ...MenuProps,
      }}
      {...other}
      label={labelAbove || labelLeft ? null : props.label}
    >
      {props.children}
    </SelectField>
  )

  const roundedSelect = () => {
    if (!rounded) return {};

    return {
      borderRadius: '24px'
    }
  }

  const sxProps = {
    sx: {
      ...sx,
      ...roundedSelect(),
      ...(size === 'xs' && {
        '& .MuiInputBase-input': {
          padding: '2.5px 14px',
        }
      })
    }
  }

  const generatedLabelId = `${useId()}-label`;
  const labelId = props.labelId || (props.label ? generatedLabelId : undefined);

  return (
    <>
      <FormControl fullWidth={fullWidth} className={formControlClasses}

      >

        {labelAbove ? (
          <FormLabelStyled sx={labelSx}>{`${props.label} ${props.required ? '*' : ''}`}</FormLabelStyled>
        ) : (
          !labelLeft && <>
            {props?.label ? (<InputLabel id={labelId} shrink>{`${props.label} ${props.required ? '*' : ''}`}</InputLabel>) : null}
          </>
        )}

        {labelLeft ? (
          <>
            <Grid container>
              <Grid className="text-vertical" item size={{ ...gridProps.left }}>
                <Typography variant="strong" component="strong" >{props.label}</Typography>
              </Grid>
              <Grid item size={{ ...gridProps.right }}>
                <SelectField
                  displayEmpty={displayEmpty}
                  MenuProps={{
                    disableScrollLock: false,
                    ...MenuProps,
                  }}
                  {...sxProps}
                  size={size}
                  {...other}
                  ref={ref}
                  labelId={labelAbove || labelLeft ? undefined : labelId}
                  label={labelAbove || labelLeft ? null : props.label}
                >
                  {props.children}
                </SelectField>
              </Grid>
            </Grid>
          </>
        ) : (
          <SelectField
            displayEmpty={displayEmpty}
            MenuProps={{
              disableScrollLock: false,
              ...MenuProps,
            }}
            {...sxProps}
            size={size}
            {...other}
            ref={ref}
            labelId={labelAbove || labelLeft ? undefined : labelId}
            label={labelAbove || labelLeft ? null : props.label}
          >
            {props.children}
          </SelectField>
        )}

        {
          (props.error || forceHelper) && (
            <Box>
              {/* //TODO:  if helper text is not provided by default, then show the error message  */}
              {/* //TODO:  this is because if the error is true, the helper text will be red  */}
              <FormHelperText sx={{ m: 0, ...helperTextSx }} error={props.isError}>
                {helperText}
              </FormHelperText>

            </Box>
          )
        }
      </FormControl>
    </>
  );
});

export default SelectInput;